import { rootApi } from "../rootApi";
import { TabulationReport } from "./types";
import { IPaginationResponse, IInstitutionNotification } from "../types";

export const tabulationApis = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    sendTabulationReport: builder.mutation<
      TabulationReport,
      { proxyId: string }
    >({
      query: ({ proxyId }) => ({
        url: `proxy-events/${proxyId}/tabulation-reports/`,
        method: "POST",
      }),
      invalidatesTags: (_result, _, arg) => [
        { type: "tabulationReports", id: arg.proxyId },
      ],
    }),
    resendTabulationReport: builder.mutation<
      void,
      { proxyId: string; reportId: string }
    >({
      query: ({ proxyId, reportId }) => ({
        url: `proxy-events/${proxyId}/tabulation-reports/${reportId}/resend/`,
        method: "POST",
      }),
      invalidatesTags: (_result, _, arg) => [
        { type: "tabulationReports", id: arg.proxyId },
        { type: "institutionNotifications", id: arg.reportId },
      ],
    }),
    tabulationReports: builder.query<
      IPaginationResponse<TabulationReport>,
      { proxyId: string }
    >({
      query: ({ proxyId }) => ({
        url: `proxy-events/${proxyId}/tabulation-reports/`,
      }),
      providesTags: (_result, _, arg) => [
        "tabulationReports",
        { type: "tabulationReports", id: arg.proxyId },
      ],
    }),
    tabulationReportInstitutionNotifications: builder.query<
      IInstitutionNotification[],
      { proxyId: string; reportId: string }
    >({
      query: ({ proxyId, reportId }) => ({
        url: `proxy-events/${proxyId}/tabulation-reports/${reportId}/institution-notifications/`,
      }),
      providesTags: (_result, _, arg) => [
        { type: "institutionNotifications", id: arg.reportId },
      ],
    }),
  }),
});

export const {
  useTabulationReportsQuery,
  useSendTabulationReportMutation,
  useResendTabulationReportMutation,
  useTabulationReportInstitutionNotificationsQuery,
} = tabulationApis;
